export default __webpack_public_path__ + "static/media/request-render-full-linux.acffc43b.avif";